export const showcaseSectionSx = {
  backgroundColor: '#ECEEF2',
  paddingTop: { xs: '28px', md: '40px' },
  paddingBottom: { xs: '48px', md: '72px' },
} as const;

export const showcaseGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: { xs: 3, md: 4 },
} as const;

export const showcaseCardSx = {
  height: '300px',
  borderRadius: '8px',
  overflow: 'hidden',
  marginBottom: '16px',
  position: 'relative',
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
} as const;

export const showcaseCardImageSx = {
  position: 'absolute',
  height: '100%',
  width: '100%',
  inset: '0px',
  color: 'transparent',
} as const;

export const showcaseItemSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
} as const;

export const showcaseTitleSx = {
  color: '#0A2440',
  fontSize: { xs: '30px', md: '38px' },
  fontWeight: 700,
  lineHeight: 1.15,
  marginBottom: 3,
} as const;

export const showcaseDescriptionSx = {
  marginTop: 1.5,
  color: '#0A2440',
  fontSize: { xs: '16px', md: '18px' },
  lineHeight: 1.6,
} as const;

export const comboSectionSx = {
  marginTop: { xs: 5, md: 8 },
} as const;

export const comboCardSx = (index: number) => ({
  borderRadius: '8px',
  backgroundColor: index % 2 === 0 ? '#163A69' : '#A55F1A',
  color: '#FFFFFF',
  padding: { xs: '14px 16px', md: '18px 20px' },
  '&:not(:first-of-type)': {
    marginTop: '16px',
  },
});

export const comboCardTitleRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
} as const;

export const comboCardTitleSx = {
  fontWeight: 700,
  fontSize: { xs: '16px', md: '24px' },
  lineHeight: 1.2,
} as const;

export const comboCardContentSx = {
  fontSize: { xs: '13px', md: '14px' },
  lineHeight: 1.55,
} as const;

export const comboBookNowWrapSx = {
  marginTop: { xs: '24px', md: '32px' },
  display: 'flex',
  justifyContent: 'center',
} as const;

export const comboBookNowButtonSx = {
  minWidth: '120px',
  height: '40px',
  borderRadius: '6px',
  backgroundColor: '#A55F1A',
  color: '#FFFFFF',
  fontWeight: 700,
  fontSize: '22px',
  lineHeight: 1,
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#8F5115',
    boxShadow: 'none',
  },
} as const;

export const hoianToursRichContentGlobalStyles = {
  '.hoiantours-rich-content a': {
    color: '#A35714 !important',
  },
  ".hoiantours-rich-content a.text-secondary, .hoiantours-rich-content a[class*='text-secondary']": {
    color: '#A35714 !important',
  },
  ".hoiantours-rich-content a.font-medium, .hoiantours-rich-content a[class*='font-medium']": {
    fontWeight: '500 !important',
  },
  ".hoiantours-rich-content a:hover, .hoiantours-rich-content a.hover\\:underline:hover, .hoiantours-rich-content a[class*='hover:underline']:hover, .hoiantours-rich-content a[class*='hover\\\\:underline']:hover": {
    textDecoration: 'underline !important',
  },
} as const;
